import React, {Component} from 'react'
import {Card, CardBody, Button} from 'reactstrap';
import StdTable from '../StdTable'
import StdForm from '../StdForm'
import StdButton from '../StdButton'
import ActionFormModal from '../StdForm/ActionFormModal'
import CreditValidator from '../../validators/Credit'
import CreditLogValidator from '../../validators/CreditLog'

import { Trans } from "react-i18next";
import {Edit3, Trash, UserPlus, Plus} from 'react-feather';
class Credits extends Component{
    constructor(props) {
	super(props);
	this.state = {modal: false} 
    }
    
    componentDidMount(){
	this.props.getCredits()
    }

    render(){
	const {credits, createCredit, deleteCredit, addCreditLog} = this.props

	const Form = StdForm({form_name: 'addCreditForm'})
	const {modal} = this.state
	const toggle = () => this.setState({ modal: !modal });

	const fields = [{name: 'name', type: 'text'}]

	const EditCredit = (props) => <ActionFormModal  buttonProps = {{ size: "sm"}} action_text={<Edit3 size='12' />} trans_prefix="credits"  fields={fields} form_name="edit_credit" {...props} submitAction={createCredit}  validation={CreditValidator} />
	const AddCreditLog = (props) => <ActionFormModal buttonProps = {{ size: "sm"}} action_text={<Trans>credits.charge</Trans>} trans_prefix="credits"  fields={[{name: 'amount', type: 'number'}]} form_name="add_credit_log" {...props} submitAction={addCreditLog} validation={CreditLogValidator}/>
	const DeleteCredit = ({id}) => <StdButton buttonProps = {{color:"danger", size: "sm"}}  action_text={<Trash size='12' />} buttonAction = {() => deleteCredit(id)} confirmation={'Sei sicuro?'}  />

	    return (	    
	    <Card>
		<CardBody>

		    <ActionFormModal action_text={<Plus size='12' />} fields={fields} form_name="add_credit" submitAction={createCredit}  trans_prefix="credits" validation={CreditValidator}  />
		    
		    <StdTable collection={credits} fields={['name', {name: 'current_amount', type: 'number'}]} actions={[AddCreditLog, EditCredit, DeleteCredit]} trans_prefix="credits" actions_props={['id']} collection_key="id" />
		    
		</CardBody>
	    </Card>
	    )
    }
}
export default Credits
